import React, { useState } from 'react'
import Navbar from '../components/Navbar';
// eslint-disable-next-line
import Sidebar from '../components/Sidebar'
import SectionOne from '../components/Sections/SectionOne/SectionOne';
import SectionTwo from '../components/Sections/SectionTwo/SectionTwo';
import SectionThree from '../components/Sections/SectionThree/SectionThree';
import SectionFour from '../components/Sections/SectionFour/SectionFour';
import SectionSix from '../components/Sections/SectionSix/SectionSix';
// eslint-disable-next-line
import SectionFive from '../components/Sections/SectionFive/SectionFive';
import Footer from '../components/Footer';

const Home = () => {
    const [isOpen,setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            {/* <Sidebar isOpen={isOpen} toggle={toggle}/> */}
            <Navbar toggle={toggle}/>
            <SectionOne />
            <SectionTwo />
            <SectionThree />
            <SectionFour/>
            <SectionFive />
            <SectionSix />
            <Footer />
        </>
    )
}

export default Home
